import { render, staticRenderFns } from "./ResetPasswordScreen.vue?vue&type=template&id=27bd480a&"
import script from "./ResetPasswordScreen.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports